import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSearchText = createSelector(
  [(store: RootState) => store.documentsSignerList.searchText],
  (text) => text
);
